export default {
    basket: [],
    basketUID: null,
    waitingListItem: null,
}
